import { render, staticRenderFns } from "./FileVolumeIcon.vue?vue&type=template&id=5af9a5bf"
import script from "./FileVolumeIcon.vue?vue&type=script&lang=js"
export * from "./FileVolumeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports